import { useState, useEffect, useRef, RefObject } from 'react';
import { useMediaQuery } from 'react-responsive';
import { breakpoints } from '@instamenu/ui-vanilla-extract';

export const useNavbarVisibility = (ref: RefObject<HTMLElement | null>, top: number) => {
  const [isHidden, setIsHidden] = useState(false);
  const hideThreshold = useRef<number | null>(null);
  const isDesktop = useMediaQuery({ query: breakpoints.tablet });

  useEffect(() => {
    const controlNavbar = () => {
      const menuSection = ref.current;
      if (!menuSection) return;
      // remember the top of the section
      if (hideThreshold.current === null && menuSection.getBoundingClientRect().top <= top) {
        hideThreshold.current = window.scrollY;
      }
      setIsHidden(hideThreshold.current !== null && window.scrollY >= hideThreshold.current);
    };

    window.addEventListener('scroll', controlNavbar);
    return () => window.removeEventListener('scroll', controlNavbar);
  }, [isDesktop, ref, top]);

  if (isDesktop) return null;

  return isHidden;
};
